import { LoaderScreen } from '@/components/Elements';
import { apolloClient, ApolloProvider } from '@/lib/graphql';
import { queryClient } from '@/lib/react-query';
import { ErrorScreen } from '@/pages/ErrorScreen';
import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter as Router } from 'react-router-dom';

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <React.Suspense fallback={<LoaderScreen />}>
      <ApolloProvider client={apolloClient}>
        <QueryClientProvider client={queryClient}>
          <Router>
            <ErrorBoundary FallbackComponent={ErrorScreen}>
              {children}
            </ErrorBoundary>
          </Router>
        </QueryClientProvider>
      </ApolloProvider>
    </React.Suspense>
  );
};
